import { axiosInstance } from './api';

/** Юрлица (Алексей 23.10, #2010) — справочник внутри группы филиалов; права от группы.
 *  BE plugins/ops_tasks/api/legal.py. */
export interface LegalEntityDto {
  id: number;
  name: string;
  inn: string;
  group: { id: number; name: string };
  zones: { id: number; name: string }[];
  connections: { id: number; name: string; enabled: boolean; last_error: string }[];
}

export const legalEntitiesKey = (groupId?: number) => ['legal-entities', groupId ?? 'mine'] as const;

export const listLegalEntities = (groupId?: number) =>
  axiosInstance.get<{ legal_entities: LegalEntityDto[] }>('/ops_tasks/legal-entities/', { params: groupId ? { group: groupId } : {} });

export const createLegalEntity = (body: { group: number; name: string; inn: string; zone_ids: number[] }) =>
  axiosInstance.post<LegalEntityDto>('/ops_tasks/legal-entities/', body);

export const updateLegalEntity = (id: number, body: Partial<{ name: string; inn: string; zone_ids: number[] }>) =>
  axiosInstance.patch<LegalEntityDto>(`/ops_tasks/legal-entities/${id}/`, body);

export const deleteLegalEntity = (id: number) => axiosInstance.delete(`/ops_tasks/legal-entities/${id}/`);
